module.exports = __webpack_public_path__ + "img/9788952755735.0ff9c505.jpg";